(function () {
  'use strict';

  var BUCKET = 'b2b-docs';
  var MAX_SIZE_MB = 10;

  function initUpload(section) {
    if (!section) return;
    var url = (section.getAttribute('data-supabase-url') || '').trim();
    var anonKey = (section.getAttribute('data-supabase-anon-key') || '').trim();
    var fileInput = section.querySelector('input[data-b2b-file]');
    var docUrlInput = section.querySelector('[data-b2b-doc-url]');
    if (!fileInput || !docUrlInput || !url || !anonKey) return;

    var supabase;
    try {
      if (typeof window.supabase === 'undefined') return;
      supabase = window.supabase.createClient(url, anonKey);
    } catch (e) {
      console.warn('B2B Supabase: init failed', e);
      return;
    }

    var statusEl = document.createElement('span');
    statusEl.className = 'b2b__file-status';
    statusEl.setAttribute('aria-live', 'polite');
    fileInput.parentNode.appendChild(statusEl);

    function setStatus(text, isError) {
      statusEl.textContent = text;
      statusEl.style.color = isError ? '#c00' : '';
    }

    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) {
        docUrlInput.value = '';
        setStatus('');
        return;
      }

      if (file.size > MAX_SIZE_MB * 1024 * 1024) {
        setStatus('File too large. Max ' + MAX_SIZE_MB + 'MB.', true);
        fileInput.value = '';
        return;
      }

      setStatus('Uploading…');
      var safeName = (file.name || 'file').replace(/[^a-zA-Z0-9._-]/g, '_');
      var path = Date.now() + '_' + safeName;

      supabase.storage.from(BUCKET).upload(path, file, { upsert: true })
        .then(function (res) {
          if (res.error) throw res.error;
          var pub = supabase.storage.from(BUCKET).getPublicUrl(path);
          docUrlInput.value = pub.data.publicUrl || '';
          setStatus('Uploaded.');
        })
        .catch(function (err) {
          setStatus('Upload failed. Try again.', true);
          docUrlInput.value = '';
          console.warn('B2B Supabase upload error', err);
        });
    });
  }

  function init() {
    document.querySelectorAll('.b2b').forEach(initUpload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.b2b') || e.target;
    if (section && section.classList && section.classList.contains('b2b')) initUpload(section);
  });
})();
